export default __webpack_public_path__ + "static/media/netresto.0a743f77.jpg";